<template>
    <kt-panel>
        <div class="card-body">
            <kt-form-section>
                <kt-form-row>
                    <kt-col lg="3" md="3" xs="12">
                      <kt-form-group>
                        <kt-form-label for="card_number">
                          {{ $t('label.psp_title') }}
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            id="psp"
                            class="form-control"
                            name="psp"
                            v-model="query.psp"
                            v-if="gateway"
                        >
                          <option
                              v-for="(terminal, index) in gateway.terminal"
                              :key="index"
                              :value="terminal.psp"
                          >
                            {{ pspTypes(terminal.psp) }}
                          </option>
                        </kt-form-select>
                      </kt-form-group>
                    </kt-col>

                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="referenceId">
                                {{ $t('transactions-report.referenceCode') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="referenceCode"
                                    name="referenceCode"
                                    id="referenceCode"
                                    v-model="query.referenceCode"
                                    dir="ltr"
                            />
                        </kt-form-group>
                    </kt-col>

                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="minAmount">
                                {{ $t('transactions-report.minAmount') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="minAmount"
                                    dir="ltr"
                                    name="minAmount"
                                    id="minAmount"
                                    v-model="query.minAmount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="maxAmount">
                                {{ $t('transactions-report.maxAmount') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="maxAmount"
                                    dir="ltr"
                                    name="maxAmount"
                                    id="maxAmount"
                                    v-model="query.maxAmount"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                      <kt-form-group>
                        <kt-form-label for="switchTraceNo">
                          {{ $t('transactions-report.traceCode') }}
                        </kt-form-label>
                        <kt-form-control
                            ref="traceCode"
                            name="traceCode"
                            id="traceCode"
                            v-model="query.traceCode"
                            dir="ltr"
                        />
                      </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="card_number">
                                {{ $t('label.card_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="card_number"
                                    name="card_number"
                                    id="card_number_input"
                                    style="direction:ltr"
                                    v-model="query.card_number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="from_date">
                                {{ $t('label.from_date') }}
                            </kt-form-label>
                            <button id="reset_from_date"
                                    @click="clearFromDate"
                                    class="btn text-danger trash-btn"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    color="#00c1a4"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="from_date"
                                    name= "from_date"
                                    v-model="query.from_date"
                                    type="datetime"/>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xs="12" sm="6" md="3">
                        <kt-form-group>
                            <kt-form-label for="to_date">
                                {{ $t('label.to_date') }}
                            </kt-form-label>
                            <button id="reset_to_date"
                                    @click="clearToDate"
                                    class="btn trash-btn text-danger"
                            >
                                <i class="la la-trash-o"></i>
                            </button>
                            <datePicker
                                    color="#00c1a4"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                    input-class="form-control"
                                    id="to_date"
                                    name= "to_date"
                                    v-model="query.to_date"
                                    type="datetime"
                            />
                        </kt-form-group>
                    </kt-col>
                </kt-form-row>
            </kt-form-section>
            <div class="d-flex justify-content-between">
                <div>
                    <button class="btn btn-success btn-wide" @click="action($event, query)">
                        {{ $t('transactions-report.send-request') }}
                    </button>
                </div>
                <div>
                    <button
                            class="btn btn-success btn-wide float-right"
                            size="md"
                            type="button"
                            id="export_psp_transations_btn"
                            @click="exportExcel($event, query)"
                    >
                        {{ $t('btn.export_transaction_to_excel') }}
                    </button>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

    import Inputmask from "inputmask";
    import { pspTypes } from "@/constants/gatewayTypes";

    export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            exportExcel: {
                default: function(e, query) {},
                required: true,
            },
            gateway:{
              required: true
            },
            psp: {
              required: true
            }
        },
        mounted() {
            setTimeout( function () {
                Inputmask("9999-9999-9999-9999").mask(document.querySelectorAll('#card_number_input'))
            }, 5000)
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
        },
        data() {
            return {
                query: {
                  psp: this.psp
                },
                pspTypes
            }
        },
    }
</script>

<style>

</style>